// React
import { Fragment, useEffect } from "react"

// Form
import { useFormContext, useWatch } from "react-hook-form"

// Types
import { FormType } from "../../utils"

// Utils
import { useDataCode } from "./utils"

export function Code(params: {
  reject_code: string
  jenis: number
}) {
  // Hooks
  const { data, refetch } = useDataCode()
  
  // Form
  const { control, setValue } = useFormContext<FormType>()
  
  const transaction_date = useWatch({
    control,
    name: "transaction_date"
  })
  
  useEffect(() => {
    refetch({
      ...params,
      date_request: transaction_date
    })
    // eslint-disable-next-line
  }, [transaction_date])

  useEffect(() => {
    setValue("trx_received_code",data)
    // eslint-disable-next-line
  }, [data])
  
  return <Fragment>{data}</Fragment>
}